import { useReactiveVar } from '@apollo/client';
import React from 'react';
import VerticalLine from 'src/components/VerticalLine';
import { INLINE, VIEW_CONTEXT } from 'src/constants';
import DensityToggle from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/DensityToggle/DensityToggle';
import HomePagination from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/HomePagination/HomePagination';
import LayoutIcons from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/LayoutIcons/LayoutIcons';
import SelectAllCheckbox from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/SelectAllCheckbox/SelectAllCheckbox';
import ShowMetadataSwitch from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/ShowMetadataSwitch/ShowMetadataSwitch';
import SortBy from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/SortBy/SortBy';
import TopPaginationActions from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/TopPaginationActions/TopPaginationActions';
import styles from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/TopPaginationNavBarStyles';
import { useMyPerms } from 'src/hooks/perms';
import { akomiMediaCardGridVar } from 'src/store/akomiMediaCardGridVar';

interface UserPerms {
  userPerms?: Record<string, boolean>;
}

interface MyPermissionsData {
  myPermissions?: UserPerms;
}

const TopPaginationNavBar: React.FC = () => {
  const classes = styles();
  const { data: myPerms } = useMyPerms() as { data?: MyPermissionsData };
  const { layout } = useReactiveVar(akomiMediaCardGridVar);

  return (
    <div className={classes.topPaginationNavBar}>
      <div className={classes.flexDisplay}>
        <SortBy />
        <VerticalLine />
        <SelectAllCheckbox />
        <VerticalLine />
        <TopPaginationActions permissions={myPerms?.myPermissions?.userPerms} />
      </div>
      <HomePagination showRecordCount />

      <div className={classes.flexDisplay}>
        {layout !== INLINE && (
          <React.Fragment>
            <ShowMetadataSwitch />
            <VerticalLine />
          </React.Fragment>
        )}
        <DensityToggle context={VIEW_CONTEXT.LIBRARY} target={layout === INLINE ? 'listViewDensity' : 'density'} />
        <VerticalLine />
        <LayoutIcons context={VIEW_CONTEXT.LIBRARY} />
      </div>
    </div>
  );
};

export default TopPaginationNavBar;
